import { render } from "./App.vue?vue&type=template&id=377af74c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=377af74c&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__